import { getCryptoDecimals, isCryptoCode } from 'shared/src/cryptoUtils';

export function formatRenderedCurrency(
  amount: number,
  currency: string,
  maximumFractionDigits?: number
) {
  const formatAsDecimal = () => {
    const value = new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: maximumFractionDigits
        ? maximumFractionDigits
        : getCryptoDecimals(currency)
    }).format(amount);

    return `${value} ${currency.toUpperCase()}`;
  };

  if (isCryptoCode(currency)) {
    return formatAsDecimal();
  }

  try {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: maximumFractionDigits ? maximumFractionDigits : 2
    }).format(amount);
  } catch {
    return formatAsDecimal();
  }
}

export function formatDecimalAmount(amount: number): string {
  return new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}
